import { UserRole } from "../hooks/useUserRole";

export interface NavItemDef {
  emoji: string;
  label: string;
  url: string;
  isSection?: boolean; // renders as a non-clickable divider label
}

// ─── Per-role nav definitions ─────────────────────────────────────────────────

// md or Top heirchey users:-  Superior Admin
const SUPERIOR_ADMIN_NAV: NavItemDef[] = [
  { emoji: "🏠", label: "Dashboard", url: "/dashboard" },
  { emoji: "🔍", label: "Employee", url: "/pages/employee" },
  { emoji: "📊", label: "Track Attendance", url: "/pages/track-attendance" },
  { emoji: "✅", label: "Correct Attendance",    url: "/pages/correct-attendance"   },
  { emoji: "📋", label: "Onboarding Review", url: "/pages/onboarding-review" },
  { emoji: "─", label: "FINANCE & REPORTS", url: "", isSection: true },
  { emoji: "💰", label: "Payroll & Reports", url: "/finance/payroll" },
  { emoji: "🎯", label: "Incentives", url: "/finance/payroll/incentives" },
  { emoji: "🔔", label: "Notifications", url: "/finance/notifications" },
  { emoji: "📥", label: "My Letters", url: "/pages/my-letters" },
  { emoji: "🧾", label: "My Payslips", url: "/pages/my-payslips" },
  { emoji: "⚙️", label: "Settings", url: "/pages/settings" },
];

// Manager:- Super Admin
const SUPER_ADMIN_NAV: NavItemDef[] = [
  { emoji: "🏠", label: "Dashboard", url: "/dashboard" },
  { emoji: "📊", label: "MY Attendance", url: "/pages/my-attendance" },
  { emoji: "👨‍💼", label: "Manager Panel", url: "/pages/manager-portal" },
  { emoji: "📊", label: "Track Attendance", url: "/pages/track-attendance" },
  { emoji: "📊", label: "Leave & WFH", url: "/pages/leave-wfh" },
  { emoji: "✅", label: "Correct Attendance",    url: "/pages/correct-attendance"   },
  { emoji: "📋", label: "Onboarding Checklist", url: "/pages/onboarding-checklist" },
  { emoji: "📋", label: "Onboarding Review", url: "/pages/onboarding-review" },
  { emoji: "🎯", label: "Incentives", url: "/finance/payroll/incentives" },
  { emoji: "🔔", label: "Notifications", url: "/finance/notifications" },
  { emoji: "📥", label: "My Letters", url: "/pages/my-letters" },
  { emoji: "🧾", label: "My Payslips", url: "/pages/my-payslips" },
  { emoji: "⚙️", label: "Settings", url: "/pages/settings" },
];

//Team lead or similar role :- Admin
const ADMIN_NAV: NavItemDef[] = [
  { emoji: "🏠", label: "Dashboard", url: "/dashboard" },
  { emoji: "📊", label: "MY Attendance", url: "/pages/my-attendance" },
  { emoji: "👨‍💼", label: "Lead Panel", url: "/pages/manager-portal" },
  { emoji: "📊", label: "Leave & WFH", url: "/pages/leave-wfh" },
  { emoji: "✅", label: "Correct Attendance",    url: "/pages/correct-attendance"   },
  { emoji: "📋", label: "Onboarding Checklist", url: "/pages/onboarding-checklist" },
  { emoji: "📋", label: "Onboarding Review", url: "/pages/onboarding-review" },
  { emoji: "🎯", label: "Incentives", url: "/finance/payroll/incentives" },
  { emoji: "🔔", label: "Notifications", url: "/finance/notifications" },
  { emoji: "📥", label: "My Letters", url: "/pages/my-letters" },
  { emoji: "🧾", label: "My Payslips", url: "/pages/my-payslips" },
  { emoji: "⚙️", label: "Settings", url: "/pages/settings" },
];

// Accounts or Hr, :- Moderator
const MODERATOR_NAV: NavItemDef[] = [
  { emoji: "🏠", label: "Dashboard", url: "/dashboard" },
  { emoji: "📊", label: "MY Attendance", url: "/pages/my-attendance" },
  { emoji: "🔍", label: "Employee", url: "/pages/employee" },
  { emoji: "📊", label: "Leave & WFH", url: "/pages/leave-wfh" },

  { emoji: "👤", label: "Onboarding", url: "/pages/onboarding" },
  { emoji: "📍", label: "Location Management",   url: "/pages/locations"            },
  // { emoji: "📷", label: "Register Face",         url: "/face/register"              },

  { emoji: "🗓️", label: "Attendance", url: "/dashboard/attendance" },
  { emoji: "📊", label: "Track Attendance", url: "/pages/track-attendance" },
  {
    emoji: "✅",
    label: "Correct Attendance",
    url: "/pages/correct-attendance",
  },
  { emoji: "📋", label: "Onboarding Checklist", url: "/pages/onboarding-checklist" },
  { emoji: "📋", label: "Onboarding Review", url: "/pages/onboarding-review" },

  { emoji: "─", label: "FINANCE & MORE", url: "", isSection: true },
  { emoji: "💰", label: "Payroll & Reports", url: "/finance/payroll" },
  { emoji: "🎯", label: "Incentives", url: "/finance/payroll/incentives" },
  { emoji: "📄", label: "Leave/Joining Letter", url: "/finance/letters/leave-joining" },
  { emoji: "🔔", label: "Notifications", url: "/finance/notifications" },
  { emoji: "📥", label: "My Letters", url: "/pages/my-letters" },
  { emoji: "🧾", label: "My Payslips", url: "/pages/my-payslips" },
  { emoji: "⚙️", label: "Settings", url: "/pages/settings" },
];

// Employee or users:-  User
const USER_NAV: NavItemDef[] = [
  { emoji: "🏠", label: "Dashboard", url: "/dashboard" },
  { emoji: "📊", label: "My Attendance", url: "/pages/my-attendance" },
  { emoji: "📊", label: "Leave & WFH", url: "/pages/leave-wfh" },
  { emoji: "📋", label: "Onboarding Checklist", url: "/pages/onboarding-checklist" },
  { emoji: "🔔", label: "Notifications", url: "/finance/notifications" },
  { emoji: "📥", label: "My Letters", url: "/pages/my-letters" },
  { emoji: "🧾", label: "My Payslips", url: "/pages/my-payslips" },
  { emoji: "⚙️", label: "Settings", url: "/pages/settings" },
];

const CLUSTER_USER_NAV: NavItemDef[] = [
  { emoji: "🏠", label: "Dashboard", url: "/dashboard" },
  { emoji: "🗓️", label: "Attendance", url: "/dashboard/attendance" },
  { emoji: "📊", label: "Track Attendance", url: "/pages/track-attendance" },
  { emoji: "📈", label: "Analytics", url: "/dashboard/analyticspg" },
  { emoji: "📋", label: "Onboarding Checklist", url: "/pages/onboarding-checklist" },
  { emoji: "📥", label: "My Letters", url: "/pages/my-letters" },
  { emoji: "🧾", label: "My Payslips", url: "/pages/my-payslips" },
  { emoji: "⚙️", label: "Settings", url: "/pages/settings" },
];

// ─── Role → Nav map ───────────────────────────────────────────────────────────

export const NAV_BY_ROLE: Record<UserRole, NavItemDef[]> = {
  "Super Admin": SUPER_ADMIN_NAV,
  "Superior Admin": SUPERIOR_ADMIN_NAV,
  Admin: ADMIN_NAV,
  Moderator: MODERATOR_NAV,
  User: USER_NAV,
  "Cluster User": CLUSTER_USER_NAV,
};

// ─── Path access helper ───────────────────────────────────────────────────────

/**
 * Returns the list of URL paths accessible to a given role.
 * Section dividers (isSection: true) and empty URLs are excluded.
 */
export function getAllowedPaths(role: UserRole): string[] {
  const nav = NAV_BY_ROLE[role];
  if (!nav) return [];
  return nav
    .filter((item) => !item.isSection && item.url.length > 0)
    .map((item) => item.url);
}

/**
 * Returns true if `pathname` is accessible for the given role.
 *
 * Rules:
 *  - `/dashboard` is matched exactly — having access to the root dashboard
 *    does NOT grant access to sub-paths like `/dashboard/ecommerce`.
 *  - All other allowed paths also match their sub-paths
 *    (e.g. `/admin/parameters` covers `/admin/parameters/edit/123`).
 */
export function isPathAllowed(role: UserRole, pathname: string): boolean {
  const allowed = getAllowedPaths(role);
  return allowed.some((allowedPath) => {
    if (allowedPath === "/dashboard") {
      return pathname === "/dashboard";
    }
    return pathname === allowedPath || pathname.startsWith(allowedPath + "/");
  });
}
